import PropTypes from 'prop-types';
import SetPasswordComponent from 'Components/SetPassword';

const SetPassword = ({ strings }) => <SetPasswordComponent strings={strings} />;

SetPassword.propTypes = {
  strings: PropTypes.object.isRequired,
};

export default SetPassword;
